/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "flags/models.proto" (package "rd.flags", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * Value is a value a Flag can take.
 *
 * @generated from protobuf message rd.flags.Value
 */
export interface Value {
    /**
     * @generated from protobuf field: bool bool_val = 1
     */
    boolVal: boolean;
    /**
     * @generated from protobuf field: int64 int_val = 2
     */
    intVal: bigint;
    /**
     * @generated from protobuf field: string string_val = 3
     */
    stringVal: string;
}
/**
 * Keys are the entities that Flag Values are assigned to.
 *
 * @generated from protobuf message rd.flags.Key
 */
export interface Key {
    /**
     * @generated from protobuf field: rd.flags.Key.Type type = 1
     */
    type: Key_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uuid = 2
     */
    uuid?: UUID;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * @generated from protobuf enum rd.flags.Key.Type
 */
export enum Key_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_GLOBAL = 1;
     */
    GLOBAL = 1,
    /**
     * @generated from protobuf enum value: TYPE_COMPANY = 2;
     */
    COMPANY = 2,
    /**
     * @generated from protobuf enum value: TYPE_LOCATION = 3;
     */
    LOCATION = 3,
    /**
     * @generated from protobuf enum value: TYPE_STAFF = 4;
     */
    STAFF = 4,
    /**
     * @generated from protobuf enum value: TYPE_DOOER_STAFF = 5;
     */
    DOOER_STAFF = 5,
    /**
     * @generated from protobuf enum value: TYPE_APP = 6;
     */
    APP = 6,
    /**
     * @generated from protobuf enum value: TYPE_ENDPOINT = 7;
     */
    ENDPOINT = 7
}
/**
 * Mapping attaches a Value to a Flag for a given set of Keys.
 *
 * @generated from protobuf message rd.flags.Mapping
 */
export interface Mapping {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.flags.Flag flag = 4
     */
    flag: Flag;
    /**
     * @generated from protobuf field: rd.flags.Value value = 5
     */
    value?: Value;
    /**
     * @generated from protobuf field: map<string, rd.flags.Key> keys = 6
     */
    keys: {
        [key: string]: Key;
    };
    /**
     * @generated from protobuf field: string comment = 7
     */
    comment: string;
}
/**
 * MappingLog logs changes to Mappings
 *
 * @generated from protobuf message rd.flags.MappingLog
 */
export interface MappingLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.flags.Mapping mapping = 3
     */
    mapping?: Mapping;
}
/**
 * Flag enumerates the defined flags.
 *
 * @generated from protobuf enum rd.flags.Flag
 */
export enum Flag {
    /**
     * Place permanent flags here
     *
     * @generated from protobuf enum value: FLAG_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: FLAG_ENABLE_ADMIN_SEARCH_UPDATES = 12;
     */
    ENABLE_ADMIN_SEARCH_UPDATES = 12,
    /**
     * collect search endpoint usage data
     *
     * @generated from protobuf enum value: FLAG_LOG_SEARCH_REQUESTS = 13;
     */
    LOG_SEARCH_REQUESTS = 13,
    /**
     * minimum log level to output; 0==all
     *
     * @generated from protobuf enum value: FLAG_LOG_LEVEL = 14;
     */
    LOG_LEVEL = 14,
    /**
     * configure search matching parameters; json string
     *
     * @generated from protobuf enum value: FLAG_SEARCH_MATCH_CONFIG = 15;
     */
    SEARCH_MATCH_CONFIG = 15,
    /**
     * enable writing to dblog table
     *
     * @generated from protobuf enum value: FLAG_DBLOG = 17;
     */
    DBLOG = 17,
    /**
     * set the maximum number of webauthn pubkeys to match against
     *
     * @generated from protobuf enum value: FLAG_AUTH_KEY_MAX = 18;
     */
    AUTH_KEY_MAX = 18,
    /**
     * enable core banking
     *
     * @generated from protobuf enum value: FLAG_CORE_BANKING = 19;
     */
    CORE_BANKING = 19,
    /**
     * prevents automatic tax rate updates
     *
     * @generated from protobuf enum value: FLAG_FREEZE_TAX_RATE = 20;
     */
    FREEZE_TAX_RATE = 20,
    /**
     * polling interval for updating search indexes in ms
     *
     * @generated from protobuf enum value: FLAG_SEARCH_INDEX_INTERVAL_MS = 21;
     */
    SEARCH_INDEX_INTERVAL_MS = 21,
    /**
     * override domain for frontend search requests
     *
     * @generated from protobuf enum value: FLAG_SEARCH_DOMAIN = 22;
     */
    SEARCH_DOMAIN = 22,
    /**
     * set LLM temperature for Dooey
     *
     * @generated from protobuf enum value: FLAG_RUNDOO_AI_TEMPERATURE = 23;
     */
    RUNDOO_AI_TEMPERATURE = 23,
    /**
     * set LLM system prompt for Dooey
     *
     * @generated from protobuf enum value: FLAG_RUNDOO_AI_SYSTEM = 24;
     */
    RUNDOO_AI_SYSTEM = 24,
    /**
     * set LLM client for Dooey
     *
     * @generated from protobuf enum value: FLAG_RUNDOO_AI_CLIENT = 25;
     */
    RUNDOO_AI_CLIENT = 25,
    /**
     * set searchalytics db TTL
     *
     * @generated from protobuf enum value: FLAG_SEARCHALYTICS_TTL_SECONDS = 26;
     */
    SEARCHALYTICS_TTL_SECONDS = 26,
    /**
     * disables reading user IAM roles
     *
     * @generated from protobuf enum value: FLAG_DISABLE_IAM_ROLES = 27;
     */
    DISABLE_IAM_ROLES = 27,
    /**
     * control migration concurrency
     *
     * @generated from protobuf enum value: FLAG_MIGRATION_CONCURRENCY = 1201;
     */
    MIGRATION_CONCURRENCY = 1201,
    /**
     * enable client integrations UI
     *
     * @generated from protobuf enum value: FLAG_ENABLE_CLIENT_INTEGRATIONS_UI = 1210;
     */
    ENABLE_CLIENT_INTEGRATIONS_UI = 1210,
    /**
     * enable db validation
     *
     * @generated from protobuf enum value: FLAG_ENABLE_DB_VALIDATION = 1218;
     */
    ENABLE_DB_VALIDATION = 1218,
    /**
     * enable RDC UI
     *
     * @generated from protobuf enum value: FLAG_ENABLE_RDC_UI = 1221;
     */
    ENABLE_RDC_UI = 1221,
    /**
     * FLAG_ENABLE_FIN_API
     *
     * enable sale fulfillment location
     *
     * @generated from protobuf enum value: FLAG_FULFILLMENT_LOCATION = 1239;
     */
    FULFILLMENT_LOCATION = 1239,
    /**
     * enable messages/CRM
     *
     * @generated from protobuf enum value: FLAG_MESSAGES = 1244;
     */
    MESSAGES = 1244,
    /**
     * enable pay statement balance in receivables
     *
     * @generated from protobuf enum value: FLAG_ENABLE_PAY_STATEMENT_BALANCE = 1245;
     */
    ENABLE_PAY_STATEMENT_BALANCE = 1245,
    /**
     * send emails from client's domain
     *
     * @generated from protobuf enum value: FLAG_ENABLE_CUSTOM_EMAIL_CONFIG = 1274;
     */
    ENABLE_CUSTOM_EMAIL_CONFIG = 1274,
    /**
     * enable sending prices to vendor on PO
     *
     * @generated from protobuf enum value: FLAG_ENABLE_SENDING_PRICES_ON_PO = 1280;
     */
    ENABLE_SENDING_PRICES_ON_PO = 1280,
    /**
     * enable using V2 alternate pricing
     *
     * @generated from protobuf enum value: FLAG_ENABLE_ALTERNATE_PRICING_V2 = 1281;
     */
    ENABLE_ALTERNATE_PRICING_V2 = 1281,
    /**
     * IntegrationVendor enum values allowed in catalog search
     *
     * @generated from protobuf enum value: FLAG_CATALOG_SEARCH_ALLOWED_VENDORS = 1284;
     */
    CATALOG_SEARCH_ALLOWED_VENDORS = 1284,
    /**
     * show/hide company pricing info section in catalog PIM
     *
     * @generated from protobuf enum value: FLAG_CATALOG_PIM_COMPANY_PRICING_INFO = 1287;
     */
    CATALOG_PIM_COMPANY_PRICING_INFO = 1287,
    /**
     * enable accounting summary
     *
     * @generated from protobuf enum value: FLAG_ACCOUNTING_SUMMARY = 1291;
     */
    ACCOUNTING_SUMMARY = 1291,
    /**
     * enable admin vendor tab
     *
     * @generated from protobuf enum value: FLAG_ADMIN_VENDOR_TAB = 1294;
     */
    ADMIN_VENDOR_TAB = 1294,
    /**
     * enable transferring domains to be managed by Rundoo
     *
     * @generated from protobuf enum value: FLAG_DOMAIN_MANAGEMENT = 1295;
     */
    DOMAIN_MANAGEMENT = 1295,
    /**
     * Fan Builder reward program
     *
     * @generated from protobuf enum value: FLAG_REWARD_PROGRAM_FAN_BUILDER = 1296;
     */
    REWARD_PROGRAM_FAN_BUILDER = 1296,
    /**
     * True rewards reward program
     *
     * @generated from protobuf enum value: FLAG_REWARD_PROGRAM_TRUE_REWARDS = 1297;
     */
    REWARD_PROGRAM_TRUE_REWARDS = 1297,
    /**
     * @generated from protobuf enum value: FLAG_ENABLE_LLM_USAGE_LIMITS = 1300;
     */
    ENABLE_LLM_USAGE_LIMITS = 1300,
    /**
     * restrict POS UI to self-checkout (per-staff)
     *
     * @generated from protobuf enum value: FLAG_ENABLE_SELF_CHECKOUT = 1305;
     */
    ENABLE_SELF_CHECKOUT = 1305,
    /**
     * skip product labels in BUB
     *
     * @generated from protobuf enum value: FLAG_SKIP_BUB_PRODUCT_LABELS = 1309;
     */
    SKIP_BUB_PRODUCT_LABELS = 1309,
    /**
     * enable web e-commerce
     *
     * @generated from protobuf enum value: FLAG_ENABLE_ECOMMERCE_WEB = 1312;
     */
    ENABLE_ECOMMERCE_WEB = 1312,
    /**
     * printer id for self-checkout receipts
     *
     * @generated from protobuf enum value: FLAG_SELF_CHECKOUT_PRINTER_ID = 1314;
     */
    SELF_CHECKOUT_PRINTER_ID = 1314,
    /**
     * accept deposits and partial close outs on non-terminal sales
     *
     * @generated from protobuf enum value: FLAG_GENERALIZE_DEPOSITS_CLOSE_OUTS = 1317;
     */
    GENERALIZE_DEPOSITS_CLOSE_OUTS = 1317,
    /**
     * show editable price/cost fields for non-stock
     *
     * @generated from protobuf enum value: FLAG_ENABLE_NON_STOCK_MODAL_PRICE_COST = 1322;
     */
    ENABLE_NON_STOCK_MODAL_PRICE_COST = 1322,
    /**
     * products bub exports with more rows than this download via a GCS
     *
     * @generated from protobuf enum value: FLAG_BUB_EXPORT_GCS_ROW_THRESHOLD = 1326;
     */
    BUB_EXPORT_GCS_ROW_THRESHOLD = 1326,
    /**
     * show "Stripe setup incomplete" banner in the header
     *
     * @generated from protobuf enum value: FLAG_ENABLE_STRIPE_WARNING_BANNER = 1330;
     */
    ENABLE_STRIPE_WARNING_BANNER = 1330,
    /**
     * surface the contractor/retail customer type selector
     *
     * @generated from protobuf enum value: FLAG_ENABLE_CUSTOMER_TYPE = 1331;
     */
    ENABLE_CUSTOMER_TYPE = 1331,
    /**
     * used to be FLAG_ENABLE_UNBOUNDED_CUSTOMER_LAST_SALE
     * used to be FLAG_ENABLE_MANUAL_JOURNAL_ENTRY
     * used to be FLAG_CUSTOMER_SIGNATURE_REQUIREMENT
     *
     * enable BM data sharing toggle
     *
     * @generated from protobuf enum value: FLAG_BM_DATA_SHARING = 1339;
     */
    BM_DATA_SHARING = 1339,
    /**
     * auto-receive shipment notifications from integration vendors
     *
     * @generated from protobuf enum value: FLAG_AUTO_RECEIVE_SHIPMENTS = 1342;
     */
    AUTO_RECEIVE_SHIPMENTS = 1342,
    /**
     * Enable PPC pricing client
     *
     * @generated from protobuf enum value: FLAG_ENABLE_PPC_PRICING = 1343;
     */
    ENABLE_PPC_PRICING = 1343,
    /**
     * concurrency for statement jobs
     *
     * @generated from protobuf enum value: FLAG_STATEMENT_JOB_CONCURRENCY = 1344;
     */
    STATEMENT_JOB_CONCURRENCY = 1344,
    /**
     * resolve the initial deposit from the client-sent deposit intent\
     *
     * @generated from protobuf enum value: FLAG_INITIAL_DEPOSIT_INTENT = 1346;
     */
    INITIAL_DEPOSIT_INTENT = 1346,
    /**
     * a flag to enable the deprecated delivery
     *
     * @generated from protobuf enum value: FLAG_DEPRECATED_DELIVERY_EXPIERENCE = 1348;
     */
    DEPRECATED_DELIVERY_EXPIERENCE = 1348,
    /**
     * <= 0 disables the cron
     *
     * @generated from protobuf enum value: FLAG_PPC_CRON_BATCH_SIZE = 1351;
     */
    PPC_CRON_BATCH_SIZE = 1351,
    /**
     * send prompt/response/tool content to Datadog LLM observability
     *
     * @generated from protobuf enum value: FLAG_ENABLE_LLM_OBS_CONTENT = 1352;
     */
    ENABLE_LLM_OBS_CONTENT = 1352,
    /**
     * enable kits
     *
     * @generated from protobuf enum value: FLAG_ENABLE_KITS = 1353;
     */
    ENABLE_KITS = 1353,
    /**
     * enable Astro loyalty integration
     *
     * @generated from protobuf enum value: FLAG_ENABLE_ASTRO_LOYALTY = 1355;
     */
    ENABLE_ASTRO_LOYALTY = 1355,
    /**
     * @generated from protobuf enum value: FLAG_ENABLE_LOYALTY_DRAWER = 1356;
     */
    ENABLE_LOYALTY_DRAWER = 1356,
    /**
     * a flag to enable delivery viewing and delivery confirmation through mobile pos
     *
     * @generated from protobuf enum value: FLAG_ENABLE_DELIVERIES_MOBILE = 1358;
     */
    ENABLE_DELIVERIES_MOBILE = 1358,
    /**
     * redesigned cart line on quotes, will call and special orders
     *
     * @generated from protobuf enum value: FLAG_ENABLE_SPECIAL_ORDER_CART_REDESIGN = 1360;
     */
    ENABLE_SPECIAL_ORDER_CART_REDESIGN = 1360,
    /**
     * native loyalty program
     *
     * @generated from protobuf enum value: FLAG_ENABLE_NATIVE_LOYALTY = 1361;
     */
    ENABLE_NATIVE_LOYALTY = 1361,
    /**
     * enable tally (multi-length) products
     *
     * @generated from protobuf enum value: FLAG_ENABLE_TALLY_PRODUCTS = 1363;
     */
    ENABLE_TALLY_PRODUCTS = 1363,
    /**
     * redesigned order line on new and draft purchase orders
     *
     * @generated from protobuf enum value: FLAG_ENABLE_ORDER_LINE_REDESIGN = 1366;
     */
    ENABLE_ORDER_LINE_REDESIGN = 1366,
    /**
     * @generated from protobuf enum value: FLAG_ENABLE_ADDITIONAL_FEE_EXEMPT = 1367;
     */
    ENABLE_ADDITIONAL_FEE_EXEMPT = 1367,
    /**
     * enable tax components
     *
     * @generated from protobuf enum value: FLAG_ENABLE_TAX_COMPONENTS = 1369;
     */
    ENABLE_TAX_COMPONENTS = 1369,
    /**
     * enable bank reconciliation
     *
     * @generated from protobuf enum value: FLAG_ENABLE_BANK_RECONCILIATION = 1370;
     */
    ENABLE_BANK_RECONCILIATION = 1370,
    /**
     * enable enhanced UOM features
     *
     * @generated from protobuf enum value: FLAG_ENABLE_UOM_ENHANCEMENTS = 1371;
     */
    ENABLE_UOM_ENHANCEMENTS = 1371,
    /**
     * enable delivery route optimization on web
     *
     * @generated from protobuf enum value: FLAG_ENABLE_WEB_ROUTE_OPTIMIZATION = 1372;
     */
    ENABLE_WEB_ROUTE_OPTIMIZATION = 1372
}
// @generated message type with reflection information, may provide speed optimized methods
class Value$Type extends MessageType<Value> {
    constructor() {
        super("rd.flags.Value", [
            { no: 1, name: "bool_val", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "int_val", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "string_val", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Value>): Value {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.boolVal = false;
        message.intVal = 0n;
        message.stringVal = "";
        if (value !== undefined)
            reflectionMergePartial<Value>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Value): Value {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool bool_val */ 1:
                    message.boolVal = reader.bool();
                    break;
                case /* int64 int_val */ 2:
                    message.intVal = reader.int64().toBigInt();
                    break;
                case /* string string_val */ 3:
                    message.stringVal = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Value, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool bool_val = 1; */
        if (message.boolVal !== false)
            writer.tag(1, WireType.Varint).bool(message.boolVal);
        /* int64 int_val = 2; */
        if (message.intVal !== 0n)
            writer.tag(2, WireType.Varint).int64(message.intVal);
        /* string string_val = 3; */
        if (message.stringVal !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.stringVal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.flags.Value
 */
export const Value = new Value$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Key$Type extends MessageType<Key> {
    constructor() {
        super("rd.flags.Key", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.flags.Key.Type", Key_Type, "TYPE_"] },
            { no: 2, name: "uuid", kind: "message", T: () => UUID },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Key>): Key {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<Key>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Key): Key {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.flags.Key.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID uuid */ 2:
                    message.uuid = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uuid);
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Key, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.flags.Key.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID uuid = 2; */
        if (message.uuid)
            UUID.internalBinaryWrite(message.uuid, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.flags.Key
 */
export const Key = new Key$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Mapping$Type extends MessageType<Mapping> {
    constructor() {
        super("rd.flags.Mapping", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "flag", kind: "enum", T: () => ["rd.flags.Flag", Flag, "FLAG_"] },
            { no: 5, name: "value", kind: "message", T: () => Value },
            { no: 6, name: "keys", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Key } },
            { no: 7, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Mapping>): Mapping {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.flag = 0;
        message.keys = {};
        message.comment = "";
        if (value !== undefined)
            reflectionMergePartial<Mapping>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Mapping): Mapping {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.flags.Flag flag */ 4:
                    message.flag = reader.int32();
                    break;
                case /* rd.flags.Value value */ 5:
                    message.value = Value.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* map<string, rd.flags.Key> keys */ 6:
                    this.binaryReadMap6(message.keys, reader, options);
                    break;
                case /* string comment */ 7:
                    message.comment = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: Mapping["keys"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Mapping["keys"] | undefined, val: Mapping["keys"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Key.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.flags.Mapping.keys");
            }
        }
        map[key ?? ""] = val ?? Key.create();
    }
    internalBinaryWrite(message: Mapping, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.flags.Flag flag = 4; */
        if (message.flag !== 0)
            writer.tag(4, WireType.Varint).int32(message.flag);
        /* rd.flags.Value value = 5; */
        if (message.value)
            Value.internalBinaryWrite(message.value, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.flags.Key> keys = 6; */
        for (let k of globalThis.Object.keys(message.keys)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Key.internalBinaryWrite(message.keys[k], writer, options);
            writer.join().join();
        }
        /* string comment = 7; */
        if (message.comment !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.comment);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.flags.Mapping
 */
export const Mapping = new Mapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MappingLog$Type extends MessageType<MappingLog> {
    constructor() {
        super("rd.flags.MappingLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "mapping", kind: "message", T: () => Mapping }
        ]);
    }
    create(value?: PartialMessage<MappingLog>): MappingLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<MappingLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MappingLog): MappingLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.flags.Mapping mapping */ 3:
                    message.mapping = Mapping.internalBinaryRead(reader, reader.uint32(), options, message.mapping);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MappingLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.flags.Mapping mapping = 3; */
        if (message.mapping)
            Mapping.internalBinaryWrite(message.mapping, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.flags.MappingLog
 */
export const MappingLog = new MappingLog$Type();
